import * as React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { Header } from './Header';
import './MainLayout.scss';

import { Footer, LandingPageFooter } from './Footer';
import { UseScreenOrientation } from '@/utils/Orientation';
type MainLayoutProps = {
  children: React.ReactNode;
};

type ContextType = {
  isLandscape: boolean;
  demoConfirmationData: any;
  updateDemoConfirmationData: (data: any) => void;
};
export const UserContext = React.createContext<ContextType | undefined>(undefined);
export const MainLayout = ({ children }: MainLayoutProps) => {
  const isLandscape = UseScreenOrientation();
  const location = useLocation();
  const { slug } = useParams();
  const isScheduleDemo = location.pathname.indexOf('schedule-demo') >= 0 ? 'schedule-demo' : '';
  const isLandingPage = location.pathname == '/groomwest' ? true : false;
  const isTerms = location.pathname.includes('/terms') ? true : false;
  const [demoConfirmationData, setDemoConfirmationData] = React.useState<any>();
  const updateDemoConfirmationData = (data: any) => {
    setDemoConfirmationData(data);
  };
  return (
    <>
      {isTerms ? (
        <div>
          <UserContext.Provider
            value={{
              isLandscape: isLandscape ? isLandscape : false,
              demoConfirmationData,
              updateDemoConfirmationData: updateDemoConfirmationData,
            }}
          >
            <main>{children}</main>
          </UserContext.Provider>
        </div>
      ) : (
        <div
          className={`petsked-main-layout ${isScheduleDemo} ${
            isLandingPage ? 'landing-page' : ''
          } ${location.pathname.substring(1, location.pathname.length - 1)}`}
        >
          {!isLandingPage && <Header></Header>}
          <UserContext.Provider
            value={{
              isLandscape: isLandscape ? isLandscape : false,
              demoConfirmationData,
              updateDemoConfirmationData: updateDemoConfirmationData,
            }}
          >
            <main className={isLandingPage ? 'landing-page-height' : ''}>{children}</main>
          </UserContext.Provider>

          {!isLandingPage && <Footer />}
          {isLandingPage && <LandingPageFooter />}
        </div>
      )}
    </>
  );
};
